import { render, staticRenderFns } from "./BkRecords.vue?vue&type=template&id=079948c4&scoped=true"
import script from "./BkRecords.vue?vue&type=script&lang=js"
export * from "./BkRecords.vue?vue&type=script&lang=js"
import style0 from "./BkRecords.vue?vue&type=style&index=0&id=079948c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079948c4",
  null
  
)

export default component.exports